"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var services_1 = require("../services");
var getIdentifierFromAuthToken = function () {
    var cvIdToken = services_1.CookieProvider.get('CVIdToken').value;
    if (!cvIdToken)
        return '';
    try {
        var decodedToken = jwt_decode_1.default(cvIdToken);
        return (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.sub) || '';
    }
    catch (_a) {
        return '';
    }
};
exports.default = getIdentifierFromAuthToken;
